<template>
  <v-card class="main-content-card" flat>
    <v-toolbar flat>
      <v-toolbar-title>联合申报协议报审</v-toolbar-title>
      <span class="subheading ml-2">|</span>
      <v-btn round small color="primary" class="white--text"
             :disabled="!funcIds.includes('c_contract')"
             @click.native.stop="() => { editDbid = null; edit = true; }">
        <v-icon dark small>mail</v-icon>协议报审
      </v-btn>
    </v-toolbar>

    <v-divider/>

    <!-- 检索功能区 -->
    <v-container fluid grid-list-md class="px-4" style="background-color: rgba(245, 245, 245, 0.6);">
      <v-layout row wrap>
        <v-flex d-flex xs10>
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <v-text-field
                  label="合作协议名称"
                  v-model="form.name"
                  :clearable="true"
                  hide-details
              />
            </v-flex>

            <v-flex xs12 sm2>
              <v-text-field
                  label="负责人"
                  v-model="form.leaderName"
                  :clearable="true"
                  hide-details
              />
            </v-flex>

            <v-flex xs12 sm4>
              <v-select
                  item-text="name"
                  item-value="dbid"
                  :items="deptItems"
                  v-model="form.deptId"
                  label="归属部门"
                  hide-details
                  clearable
              />
            </v-flex>

            <v-flex xs12>
              <span>审核状态：</span>
              <v-btn-toggle
                  v-model="form.statusId"
                  class="transparent"
                  style="background:none;box-shadow:none"
              >
                <v-btn value="" flat>全部</v-btn>
                <v-btn flat v-for="s in statusItems" :key="s.dbid" :value="s.identifier">{{ s.name }}</v-btn>
              </v-btn-toggle>
            </v-flex>

          </v-layout>
        </v-flex>
        <v-flex d-flex xs2 text-xs-center>
          <div>
            <v-btn color="primary" @click="onSearch">
              <v-icon dark>search</v-icon>
              检索
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-divider/>

    <v-data-table
        :headers="headers"
        :loading="loading"
        item-key="dbid"
        :pagination.sync="query"
        :items="pageResult.items"
        :total-items="pageResult.total"
        rows-per-page-text="每页记录数"
        no-data-text="没有数据。"
        no-results-text="没有符合条件的记录。"
    >
      <template slot="items" slot-scope="props">
        <td>
          {{ props.index + 1 }}
        </td>
        <td>
          <span style="font-weight: bold">{{ props.item.name }}</span>
        </td>

        <td>
          <span style="font-weight: bold">{{ props.item.department.name }}</span>
          <br>
          {{ props.item.leaderName }} {{ props.item.leaderPhone }}
        </td>

        <td>
          <span style="font-weight: bold">{{ props.item.client }}</span>
        </td>


        <td>
          <v-tooltip top>
            <v-chip small label class="mx-0" slot="activator"
                    :color="props.item.status.color"
                    @click="() => { history=props.item.history; hist = true; }">
              {{ props.item.status.name }}
            </v-chip>
            <span>点击查看审核历史</span>
          </v-tooltip>
          <v-btn
              small depressed class="ml-1"
              color="orange"
              @click="() => { submitDbid=props.item.dbid; submitMsg=props.item.name; seal = true; }">
            填写用印单
          </v-btn>
          <v-btn
              v-if="props.item.corpSealNum || props.item.instSealNum"
              :disabled="!(props.item.statusId==='checked')"
              small depressed class="ml-1"
              color="teal"
              @click.stop="downloadSealPdf(props.item.dbid)">
            下载用印单
          </v-btn>
        </td>
        <td class="justify-center layout px-0">
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { viewDbid = props.item.dbid; view = true; }">
              <v-icon color="teal">more_horiz</v-icon>
            </v-btn>
            <span>查看</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { editDbid = props.item.dbid; edit = true; }"
                   :disabled="submitDisabled(props.item)">
              <v-icon color="teal">edit</v-icon>
            </v-btn>
            <span>编辑</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { rowIdx = props.index; submitDbid = props.item.dbid; submitMsg = props.item.name; submit = true; }"
                   :disabled="submitDisabled(props.item)">
              <v-icon color="teal">publish</v-icon>
            </v-btn>
            <span>提交</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { deleDbid = props.item.dbid; deleMsg = props.item.name; dele = true; }"
                   :disabled="submitDisabled(props.item)">
              <v-icon color="pink">delete_forever</v-icon>
            </v-btn>
            <span>删除</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>

    <x-view
        v-model="view"
        :dbid="viewDbid"
    />

    <x-submit
        v-model="submit"
        :dbid="submitDbid"
        :message="submitMsg"
        :uri="uri"
        @ok="(it) => Object.assign(pageResult.items[rowIdx],it)"
    />

    <x-edit
        v-model="edit"
        :dbid="editDbid"
        v-on:ok="onEditOk"
    />

    <x-delete
        v-model="dele"
        :message="deleMsg"
        :uri="uri"
        :dbid="deleDbid"
        v-on:ok="onDeleOk"
    />

    <x-history
        v-model="hist"
        :history="history"
        :status="statusItems"
    />

    <x-seal
        v-model="seal"
        :dbid="submitDbid"
        :message="submitMsg"
        :uri="uri"
        @ok="(it) => Object.assign(pageResult.items[rowIdx],it)"
    />

  </v-card>
</template>
<script>
import {mapGetters} from 'vuex'

import XView from './View'
import XEdit from './Edit'
import XSeal from './Seal'

import XDelete from '@/components/global/Delete'
import XSubmit from '@/components/global/Submit'
import XHistory from '@/components/global/History'

import mixin from '@/mixin'

const baseUri = '/api/coop/cooperation';
const statusUri = '/api/code/status';
const deptUri = '/api/syst/department';

export default {
  // 混入模块列表页面（index）基本功能
  mixins: [mixin.index(`${baseUri}/by/request/user`)],

  components: {XView, XEdit, XSubmit, XDelete, XHistory, XSeal},

  data() {
    return {
      uri: baseUri,

      // 检索、分页、排序条件条件
      query: {
        statusId: '',
        name: '',
        leaderName: '',
        applDateStart: '',
        applDateEnd: '',
        deptId: '',

        page: 1,
        rowsPerPage: 25,
        sortBy: null,
        descending: null,
        totalItems: null
      },

      // 检索框
      form: {
        statusId: '',
        name: '',
        leaderName: '',
        applDateStart: '',
        applDateEnd: '',
        deptId: '',
      },

      statusItems: [],

      deptItems: [],

      menuApplDateStart: false,
      applDateStart: null,

      menuApplDateEnd: false,
      applDateEnd: null,

      // 表头
      headers: [
        {text: '#', align: 'left', sortable: false, value: 'dbid', width: "2rem"},
        {text: '联合申报项目名称', align: 'left', sortable: true, value: 'name'},
        {text: '归属部门 / 负责人', align: 'left', sortable: true, value: 'deptId'},
        {text: '合作单位名称', align: 'left', sortable: true, value: 'client'},
        {text: '状态', align: 'left', sortable: true, value: 'status'},
        {text: '操作', align: 'center', sortable: false, value: 'dbid'}
      ],

      properties: {
        "wt": '委托合同',
        "ww": '外委合同'
      },

      rowIdx: null,

      view: false,
      viewDbid: null,

      submit: false,
      submitDbid: null,
      submitMsg: null,

      edit: false,
      editDbid: null,

      dele: false,
      deleDbid: null,
      deleMsg: null,

      hist: false,
      history: [],

      seal: false,

      rules: {
        startDate: [
          v => !!v || "必填项。",
          v => window.xutil.regexpDate().test(v) || '日期格式错误'
        ],
        endDate: [
          v => !!v || "必填项。",
          v => (v && window.xutil.regexpDate().test(v)) || '日期格式错误',
          v => (v && v > this.form.applDateStart) || "截止日期必须晚于起始日期。"
        ]
      }
    }
  },

  created() {
    // 加载审核状态
    this.axios.all([
      this.axios.get(statusUri, {params: {sort: 'rank.asc'}}),
      this.axios.get(deptUri, {params: {limit: 65535, disabled: 'F', sort: 'rank.asc'}}),
    ]).then(
        this.axios.spread(
            (rspStaus, rspDept) => {
              this.statusItems = rspStaus.data.items;
              this.deptItems = rspDept.data.items;
            }
        )
    )
  },

  computed: {
    ...mapGetters(['funcIds']),

  },

  methods: {
    downloadSealPdf(dbid) {
      // window.console.log("sealPdfUrl");
      const url = `${baseUri}/seal/${dbid}`
      const urlWithToken =  window.xutil.buildUrl(url, {})
      window.open(urlWithToken, "__blank")
    },
    // 检索响应函数
    onSearch() {
      Object.assign(this.query, this.form);
      this.query.page = 1;
      this.doRoute(this.query);
    },
    submitDisabled(item) {
      return !(
          // 当前用户拥有提交功能
          this.funcIds.includes('c_contract')
          // 并且，当前记录需要提交
          && item.actions.find(a => a.action === 'submit'))
    }
  }
}
</script>
